<!--
 * @Auther: 罗耀祖
 * @Date: 2022-03-17 14:02:51
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 10:59:54
 * @name: 待审批琴行
 * @Description: 待审批琴行
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\company-list-waitapprove.vue
 * @Author: desktop
-->
<template>
  <div>
    <font class="statistics"
      >共搜索到 {{ pianoCompany.pianoCompanyWaitTable.total }} 条数据</font
    >
    <table-normal>
      <template v-slot:table>
        <el-table
          :data="pianoCompany.pianoCompanyWaitTable.list"
          v-loading="loading"
          tooltip-effect="light"
          element-loading-text="数据加载中"
          fit
          :header-cell-style="{
            'background-color': $scssVars['Vars-background-bar-normal'],
            color: '#666',
          }"
          :style="{ fontSize: $scssVars['Vars-font-content-size'] }"
        >
          <el-table-column
            align="center"
            prop="agency_name"
            label="琴行名称"
            width="300"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="address"
            label="地址"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="agency_user[0].realname"
            label="姓名"
            width="200"
          >
          </el-table-column>
          <el-table-column
            align="center"
            prop="agency_user[0].mobile"
            label="手机号"
            width="200"
          >
          </el-table-column>
          <el-table-column
            align="center"
            fixed="right"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button size="mini" type="text" @click="resolve(scope.row)"
                >通过</el-button
              ><font class="clip">|</font>
              <el-button size="mini" type="text" @click="reject(scope.row)"
                >拒绝</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </template>
      <template v-slot:pagination>
        <Pagination
          class="pagination"
          :page.sync="pagination.page"
          :page-size.sync="pagination.limit"
          :total="Number(pianoCompany.pianoCompanyWaitTable.total)"
        ></Pagination>
      </template>
    </table-normal>
    <approve-resolve :pianoCompany="pianoCompany" ref="approveResolve" @approveResolveHandler="approveResolveHandler"></approve-resolve>
  </div>
</template>
<script>
import tableNormal from "@/components/public/table-normal.vue";
import approveResolve from './dialog/approve-resolve'
import { confirmation, debounceation } from '@/utils/decorator';
export default {
  name: "companyListWaitapprove",
  components: {
    tableNormal,
    approveResolve,
  },
  props: {
    pianoCompany: {
      type: Object,
    },
  },
  data() {
    return {
      status: 0,
      loading: false, //表格加载状态
      pagination: {
        //分页信息
        page: 1,
        limit: 10,
      },
    };
  },
  watch: {
    pagination: {
      handler(nv, ov) {
        this.getTable();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取表格数据
     */
    getTable() {
      this.loading = true;
      this.pianoCompany
        .getPianoCompanyWaitTable({ status: this.status, ...this.pagination })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击通过
     * @param {Object} row 行数据
     */
    @debounceation(300)
    resolve(row) {
      this.$refs.approveResolve.open(row);
    },
    approveResolveHandler(obj) {
      this.submit({
        agency_id: obj.id,
        act: 'OK',
        belong_user_id: obj.belong_user_id,
        belong_muser_id: obj.belong_muser_id,
        // credit_limit: obj.credit_limit,
        // credit_month: obj.credit_month,
      })
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击拒绝
     * @param {Object} row 行数据
     */
    @confirmation('是否确认拒绝审批？')
    reject(row) {
      this.submit({
        agency_id: row.id,
        act: -1,
      })
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 提交审核
     * @param {Object} req 请求参数
     */
    @debounceation(300)
    submit(req) {
      this.pianoCompany.verify(req).then(res => {
        this.$refs.approveResolve.cancel();//关闭弹窗
        this.getTable();
      })
    },
  },
};
</script>
<style lang="scss" scoped>
.statistics {
  font-size: $Vars-font-miniContent-size;
  color: $Vars-font-secondary-color;
}
</style>